import React, {useState} from 'react';
import styled from '@emotion/styled';

const Button = styled.button`
  background-color: ${props => props.isActive ? props.theme.colors.black : props.theme.colors.gray};
  color: ${props => props.isActive ? props.theme.colors.white : props.theme.colors.black};
  border: 1px solid ${props => props.theme.colors.stroke};
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-radius: 10px;
  cursor: pointer;
  outline: none;
  font-size: 14px;
  &:hover {
    border: 1px solid ${props => props.theme.colors.black};
  }
  width: 150px;
`;

const FilterButton = ({ title, isActive, handleClick }) => {
  return (
    <Button 
      isActive={isActive}
      onClick={ ev => {
        handleClick(ev);
      }}
    >
      {title}
    </Button>
  );
}
export default FilterButton;
